export const firebaseConfig = {
    apiKey: "AIzaSyANaM_dvlh7a6lfGgaHQrba8HAnhiQmy-k",
    authDomain: "windy-3a3ca.firebaseapp.com",
    projectId: "windy-3a3ca",
    storageBucket: "windy-3a3ca.appspot.com",
    messagingSenderId: "749847592912",
    appId: "1:749847592912:web:152f7ea2c80f819bccc3d5",
    measurementId: "G-GR88J2YZQN"
};